import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import ProjectsGrid from '../components/ProjectsGrid';

// Utility to get API base URL depending on environment
const getApiBaseUrl = () => {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  ) {
    return 'http://localhost:5000';
  }
  // Use relative URL for production
  return '';
};

const Category = () => {
  const { slug } = useParams(); // category slug from URL
  const [category, setCategory] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch category info by slug
    fetch(`${getApiBaseUrl()}/api/categories/slug/${slug}`)
      .then((res) => res.json())
      .then((data) => setCategory(data))
      .catch(() => setCategory(null));

    // Fetch projects for this category by slug
    fetch(`${getApiBaseUrl()}/api/categories/slug/${slug}/projects`)
      .then((res) => res.json())
      .then((data) => setProjects(data))
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div>Chargement...</div>;
  if (!category) return <div>Catégorie introuvable.</div>;

  return (
    <div style={{ padding: '20px', maxWidth: 900, margin: '0 auto' }}>
      <Helmet>
        <title>
          {category && category.name
            ? `Que faire avec des ${category.name.toLowerCase()} cassé(e)s: des idées DIY faciles et utiles`
            : 'Que faire avec des objets cassés : des idées DIY faciles et utiles'}
        </title>
        <meta
          name="description"
          content={
            category && category.name
              ? `Découvrez des idées simples pour recycler des ${category.name.toLowerCase()} cassé(e)s : déco, rangement, bricolage. Tutoriels + matériel nécessaire.`
              : 'Découvrez des idées simples pour recycler des objets cassés du quotidien : déco, rangement, bricolage. Tutoriels + matériel nécessaire.'
          }
        />
        <link rel="canonical" href={`https://0123456789.fr/category/${slug}`} />
      </Helmet>
      <h1
        className="projectName"
        style={{
          fontSize: 26,
          fontWeight: 700,
          margin: 0,
          textAlign: 'center',
          color: '#222',
          background: 'none',
          borderRadius: 0,
          padding: '8px 0',
          boxShadow: 'none',
        }}
      >
        {category.name ? `Que faire avec des ${category.name.toLowerCase()} : idées DIY faciles et utiles` : ''}
      </h1>
      <h2
        className="sectionTitle"
        style={{
          fontSize: 20,
          fontWeight: 600,
          margin: '24px 0 16px 0',
          color: '#2ecc40',
          textAlign: 'center',
        }}
      >
        Projets associés à cette catégorie
      </h2>
      {projects.length > 0 ? (
        <>
          <ProjectsGrid projects={projects} onProjectClick={(pid) => navigate(`/project/${pid}`)} />
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 36 }}>
            <button
              style={{
                padding: '12px 28px',
                fontSize: '18px',
                backgroundColor: 'var(--green-eucalyptus, #2ecc40)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(46,204,64,0.08)'
              }}
              onClick={() => navigate('/create-project')}
            >
              Partager ma création
            </button>
          </div>
        </>
      ) : (
        <p style={{ textAlign: 'center' }}>Aucun projet trouvé pour cette catégorie.</p>
      )}
    </div>
  );
};

export default Category;
